export default __webpack_public_path__ + "static/media/reboot-disable.f4d51c07.svg";